module.exports = __webpack_public_path__ + "img/136ne.0a4ce836.svg";